import { API_BASE } from '../../constants';
import { makeHttpGet } from '../';
import { ComparisonFundHeaderUseCase } from '../../usecases';
import { IRelatedFunds } from '../../main/comparison-fund/dto';
import {
  IFundHeader,
  IGetAssetMemory,
  ISetAssetColorRepo,
  ISetAssetMemory
} from '../../interfaces';

export const makeComparisonFundHeader = (
  fundColorRepo: ISetAssetColorRepo,
  fundMemoryRepo: IGetAssetMemory<IFundHeader> & ISetAssetMemory<IFundHeader>,
  getRelatedFunds: (fundId: string) => Promise<IRelatedFunds[]>
) => {
  const url = `${API_BASE}/funds/header`;
  const httpGet = makeHttpGet<IFundHeader>();

  return new ComparisonFundHeaderUseCase(
    url,
    httpGet,
    fundColorRepo,
    getRelatedFunds,
    fundMemoryRepo
  );
}
